import { FormGroup } from "@angular/forms";
export function LogValidatorErrors(group, formError, validationMessage) {
    const validationMessages = validationMessage;
    const formErrors = formError;
    Object.keys(group.controls).forEach((key) => {
        const abstractControl = group.get(key);
        if (abstractControl instanceof FormGroup) {
            this.logValidatorErrors(abstractControl);
        }
        else {
            formErrors[key] = "";
            if (abstractControl && !abstractControl.valid &&
                (abstractControl.touched || abstractControl.dirty)) {
                const messages = validationMessages[key];
                for (const errorKey in abstractControl.errors) {
                    if (errorKey) {
                        formErrors[key] += messages[errorKey] + "\n";
                    }
                }
            }
        }
    }, this);
}
